import { ChatController } from './chat-controller';
import { ClientCookieService } from '../services/client-cookie-service';
import { ModalController } from './modal-controller';
import { LoaderController } from './loader-controller';
import { ObfClientSettings } from '../interfaces/obf-client-settings.interface';
import { PostMessaging } from './IframeConnect/post-messaging';
import { getUrlVars, dispatchCustomEvent, scrollWindowTop, sendReport, getFormattedMailReport, clickToCall, getParentCookies, getGoogleCookieId } from '../helpers/helpers';
import { obfButtonsDataAttributes } from '../interfaces/obf-buttons-cta-attributes.interface';
import { OptionsService } from '../services/options-service';
import { AccountsController } from './accounts-controller';
import { CtaButtonsController } from './cta-buttons-controller';
import { Dependencies } from '../interfaces/dependencies-types';
import DependenciesInjector from '../helpers/dependencies-injector';
import { interactionController } from '../modules/tracking/controllers/interaction-controller';

// GLobal declare data layer
// declare global {
//     interface Window {  
//         dataLayer?: object[];
//     }
// }

export class IframeController implements Dependencies {
    
    private clientCookieService: ClientCookieService;
    public type = 'ObfInIframe';

    private obfState = {
        obfIsInit: false,
        isClosing: false,
        openExitPopup: false,
        loaderStatus: false,
        obfOpening: false,
        obfIsOpen: false,
        obfErrorInit: false
    };

    private clickInitEventListener = () => { };

    private firstOpen = false;


    private obfIframeSettings = {
        timeout: 25000,
        autoOpeningArray: [
            { queryParam: 'fs_screen', value: 'new_booking' },
            { queryParam: 'fs_screen', value: 'restored_booking' },
            { queryParam: 'form', value: 'open' },
            { queryParam: 'trigger', value: 'new_booking' },
            { queryParam: 'trigger', value: 'restored_booking' },
        ],
        autoOpen: false
    };

    private defaultHistoryPushState: any;
    private defaultHistoryReplaceState: any;
    private lastSlugObject: { slug: string } = null;

    /**
     * Contain the data of open element if obf is still not init and user click on button to open obf
     */
    private openLoaderAttrData: any;

    private appUrl: string;

    private iframeRef: HTMLIFrameElement | any;
    private iframeCon: PostMessaging;

    private lastEventFromChat: { eventType: string; data: any };

    private xrmSdkConfig: any;

    private autoOpenTimeOutInstance: number[] = [];
    private openingTimeOutInstance: number[] = [];


    // injected instances.
    private optionsService: OptionsService;
    private accountsController: AccountsController;
    private modalController: ModalController;
    private loaderController: LoaderController;
    private chatController: ChatController;
    private interaction: interactionController;
    private ctaButtonsController: CtaButtonsController;

    private obfClientSettings: ObfClientSettings;
    isHistoryManipulationBlock: boolean = false;

    public defaultErrorMessage = 'It looks like something went wrong. Please try again or get in touch with us via our <a href="/contact-us/">contact form</a>.';

    public async initialize() {

        if (
            navigator.userAgent.indexOf('Safari') != -1 &&
            navigator.userAgent.indexOf('Chrome') == -1 &&
            /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
        ) {
            // Safari
            this.defaultErrorMessage = 'We encountered an issue processing your request. Please try again or reach out to us through our <a href="/contact-us/">contact form</a> for assistance. For a smoother booking experience, you may also consider adjusting your Safari browsers privacy settings to reduce restrictions.';
        }

        this.clientCookieService = await DependenciesInjector.getRegistered('ClientCookieService');

        const urlParams = getUrlVars();
        const urlParamsPlain = decodeURI(JSON.parse('"' + window.location.search + '"'));

        if (urlParamsPlain) {
            const date: any = new Date();
            const expireTime = date.getTime() + 30*24*60*60; // 30 days in seconds from today
            this.clientCookieService.setCookie('parent_params', urlParamsPlain, expireTime);
        }

        if (urlParams) {
            for (const key in urlParams) {

                // cCheck for [campaign_abbr], [campaign_id] and [campaign_phone] and add to obfOptions
                if (key.indexOf('fs_payload') != -1 && (key.indexOf('campaign_abbr') != -1 || key.indexOf('campaign_id') != -1 || key.indexOf('campaign_phone') != -1)) {
                    const payloadValue = urlParams[key];
    
                    const payloadParam = key.substring(
                        key.indexOf("[") + 1, 
                        key.lastIndexOf("]")
                    );
    
                    const date: any = new Date();
                    const expireTime = date.getTime() + 30*24*60*60; // 30 days in seconds from today
    
                    this.clientCookieService.setCookie(payloadParam, payloadValue, expireTime);
                }
            }
        }

        this.optionsService = await DependenciesInjector.getRegistered('OptionsService') as OptionsService;
        this.obfClientSettings = this.optionsService.getObfClientSettings();


        // Inject only if accounts_url is present
        if (this.obfClientSettings.accounts_url && !this.obfClientSettings.accounts_url.includes(document.location.origin)) {
            this.accountsController = await DependenciesInjector.getRegistered('AccountsController') as AccountsController;
        }

        this.loaderController = await DependenciesInjector.getRegistered('LoaderController') as LoaderController;
        this.modalController = await DependenciesInjector.getRegistered('ModalController') as ModalController;
        this.chatController = await DependenciesInjector.getRegistered('ChatController') as ChatController;
        this.ctaButtonsController = await DependenciesInjector.getRegistered('CtaButtonsController') as CtaButtonsController;
        this.interaction = await DependenciesInjector.getRegistered('interactionController') as interactionController;

        this.appUrl = this.obfClientSettings.app_url;

        this.setStyleForIframe();

        // Set Interaction tracking init events
        this.interaction.tag("init", "id-web-" + window.location.hostname + "");
        this.interaction.tag("event","view_page",{source:""+this.obfClientSettings.phone+"", main_url:""+this.obfClientSettings.main_url+""});
     
        this.subscribeForChatEvents();

        this.ctaButtonsController.setCTAHandler(async (button, buttonAtt) => {
            if (this.obfClientSettings.init_event === 'on_click' && !this.obfState.obfIsInit) {
                this.loaderController.openLoader();
                await this.initOnClick();
                this.loaderController.closeLoader()
            }
            
            if(!this.obfState.obfIsInit) {
                this.ctaButtonsController.addSpinners(button);
            }

            if (!this.obfState.obfIsOpen) {
                this.openObf(buttonAtt);
            }
        });

        if (this.obfClientSettings.init_event === 'on_click') {
            if (this.accountsController) {
                this.accountsController.checkForLogin().catch(e => { })
            }

            const currentQueryParams = getUrlVars();
            const autoOpenQuery = this.obfIframeSettings.autoOpeningArray.find(openQuery => {
                if (currentQueryParams[openQuery.queryParam] == openQuery.value) {
                    return true;
                }
            })

            const isProCrossSell = currentQueryParams.find((queryItem: string) => {
                if (queryItem === 'cross_token') {
                    return true;
                }
            });

            if (autoOpenQuery || isProCrossSell) {
                this.loaderController.openLoader();
                this.initOnClick();
                this.loaderController.closeLoader()
            }
        }

        if (this.obfClientSettings.init_event === 'on_load') {
            this.init();
        }
    }

    public async loadObf() {
        await this.initOnClick();
    }

    public init(): Promise<boolean> {
        return new Promise((resolve, reject) => {
            this.subscribeForHistoryPopEvent();
            this.iframeRef = this.createFormIframe();
            this.iframeCon = new PostMessaging(
                this.iframeRef.contentWindow,
                this.appUrl
            );

            this.registerNotificationAndRequestHandlers();
            
            resolve(true);
        });
    }

    public async initOnClick(): Promise<void> {
        return new Promise((resolve, reject) => {
            this.subscribeForHistoryPopEvent();
            this.iframeRef = this.createFormIframe();
            this.iframeCon = new PostMessaging(
                this.iframeRef.contentWindow,
                this.appUrl
            );

            this.registerNotificationAndRequestHandlers();
            this.ctaButtonsController.addSpinners();

            this.clickInitEventListener = () => {
                resolve();
            }
        })
    }

    private subscribeForHistoryPopEvent() {
        let eventFlag = false;
        window.addEventListener('popstate', (e) => {

            // console.log('popstate', e.state);
            // console.log('historyState', history.state)
            /**  
             * This case is when the obf is open and user go back.Catch the back press and send it too the obf.
             * then obf will handle this and if is need will send data to client.js to close the obf.
             */
            if (e?.state?.type == 'siteState') {
                // When user click back in middle of opening obf.
                if (
                    this.obfState.obfIsInit &&
                    this.obfState.obfIsOpen === false && this.obfState.obfOpening === true &&
                    !this.obfState.loaderStatus &&
                    !this.obfState.openExitPopup
                ) {
                    if (!eventFlag) {
                        history.go(-1);
                    }
                }

                // When user click back after obf is open
                if (
                    this.obfState.obfIsInit &&
                    this.obfState.obfIsOpen &&
                    !this.obfState.loaderStatus &&
                    !this.obfState.openExitPopup
                ) {
                    if (!eventFlag) {
                        // console.error('history forward');
                        eventFlag = true;
                        history.go(1);
                    }
                }
            }

            if (e?.state?.type == 'obfOpen') {
                // When obfIsOpen is false and obfOpening is true obf will not watch for send navigation.
                if (eventFlag == true && this.obfState.obfIsInit && (this.obfState.obfIsOpen || this.obfState.obfOpening)) {
                    // console.error('send to iframe');
                    eventFlag = false;
                    this.iframeCon.sendNotification('navigate', 'prev');
                };

                // When is forward to obfState.Just open the obf.
                if (eventFlag == false && this.obfState.obfIsInit && this.obfState.obfIsOpen == false && this.obfState.obfOpening == false) {
                    this.firstOpen = true;
                    this.openObf({});
                };
            }
        })

        window.onbeforeunload = (event: any) => {
            if (
                this.obfState.obfIsInit &&
                this.obfState.obfIsOpen &&
                this.lastSlugObject && !this.lastSlugObject.slug.includes('confirmation')
            ) {
                event.returnValue = '';
            }
        };
    }

    private subscribeForChatEvents() {
        this.chatController.onStatesListener((e: any) => {
            if (e.type != 'chat-element') {
                this.lastEventFromChat = e;
                if (e.type == 'chat-status' && this.obfState.obfIsOpen) {
                    e.data === 'open' ? this.enableScroll() : this.disableScroll();
                }
                this.sendChatStatus();
            }
        });
    }

    private sendChatStatus() {
        if (this.obfState.obfIsInit) {
            this.iframeCon.sendNotification('chat', this.lastEventFromChat);
        }
    }

    /**
     * Is use to show loader when obf is not init and user try to open it and when we close or open obf;
     * @param removeAfterDelay
     */
    private showLoader(removeAfterDelay?: number) {
        this.loaderController.openLoader();
        if (removeAfterDelay) {
            this.loaderController.closeWithDelay(removeAfterDelay);
        } else {
            this.obfState.loaderStatus = true;
            // Set timeOut for loading obf
            this.autoOpenTimeOutInstance.push(setTimeout(() => {
                this.obfState.obfIsOpen = false;
                this.obfState.loaderStatus = false;
                this.loaderController.closeLoader();
                this.iframeCon.sendNotification('navigate', 'init');
                this.changeLocation({ eventType: 'close-iframe' });
                dispatchCustomEvent('obf-init-error', {
                    status: 500,
                    message: 'It looks like we have problem with the initialization!',
                    time: new Date(),
                });
                this.modalController.openModal(
                    undefined,
                    this.defaultErrorMessage,
                    '',
                    (response: any) => {
                        // window.location.reload();
                    }
                );
            }, this.obfIframeSettings.timeout));
        }
    }

    /**
     * Will create iframe element build correct src for it and append it to dom tree.
     */
    private createFormIframe(): HTMLIFrameElement {
        let iframeBox = document.createElement('iframe'),
            iframeSource,
            topURL = document.URL;

        let parentCookies = getParentCookies();
        
        if (topURL != undefined) {
            const currentQueryParams = getUrlVars();
            const autoOpenQuery = this.obfIframeSettings.autoOpeningArray.find(openQuery => {
                if (currentQueryParams[openQuery.queryParam] == openQuery.value) {
                    return true;
                }
            });

            const isProCrossSell = currentQueryParams.find((queryItem: string) => {
                if (queryItem === 'cross_token') {
                    return true;
                }
            });

            if (autoOpenQuery || isProCrossSell) {
                this.obfIframeSettings.autoOpen = true;
                this.openObf();
            };
        }
        const srcQueryParams = this.optionsService.getObfQueryParams();
        iframeSource = `${this.appUrl}index.html${srcQueryParams}&parentOrigin=${location.origin}`;
        if (this.accountsController?.getUserCookie()) {
            iframeSource += `&csid=${encodeURIComponent(this.accountsController?.getUserCookie())}`;
        }

        // Add Meta ad tracking param
        if (parentCookies?.hasOwnProperty('_fbc')) {
            iframeSource += `&fbclid=${getGoogleCookieId(parentCookies['_fbc'])}`;
        }
        // Add Google ad tracking param
        if (parentCookies?.hasOwnProperty('_gcl_aw')) {
            iframeSource += `&gclid=${getGoogleCookieId(parentCookies['_gcl_aw'])}`;
        }
        // Add Bing ad tracking param
        if (parentCookies?.hasOwnProperty('_uetmsclkid')) {
            iframeSource += `&msclkid=${getGoogleCookieId(parentCookies['_uetmsclkid'])}`;
        }
        iframeBox.src = iframeSource;
        iframeBox.setAttribute('id', 'iframe-box-' + new Date().getTime());
        iframeBox.setAttribute('allow', 'payment *');
        iframeBox.classList.add('obfIframe');
        document.body.appendChild(iframeBox);

        return iframeBox;
    }

    /**
     * Change displayed url to user.
     */
    private changeLocation(e: any) {
        if (typeof history.pushState != 'undefined' && typeof history.replaceState != 'undefined') {
            let UrlObject;
            switch (e.eventType) {
                case 'change-location':
                    this.lastSlugObject = e.data;

                    if (this.obfState.obfIsOpen) {
                        const newStringUrl = '#/' + e.data.slug;

                        UrlObject = this.createUrlObject(newStringUrl);
                        if (this.defaultHistoryReplaceState) {
                            this.defaultHistoryReplaceState.call(history, UrlObject, UrlObject.Title, UrlObject.Url);
                        }
                    }

                    break;
                case 'open-iframe':
                    const newStringUrl = '#/' + (this.lastSlugObject ? this.lastSlugObject.slug : '');

                    UrlObject = this.createUrlObject(newStringUrl);

                    this.sendChatStatus();
                    if (this.defaultHistoryReplaceState) {
                        this.defaultHistoryReplaceState.call(history, UrlObject, UrlObject.Title, UrlObject.Url);
                    }

                    break;
                case 'close-iframe':
                    UrlObject = this.createUrlObject('');
                    UrlObject.type = 'siteState';

                    if (this.defaultHistoryReplaceState) {
                        this.defaultHistoryReplaceState.call(history, UrlObject, UrlObject.Title, UrlObject.Url);
                    }

                    break;
            }
        }
    }

    private createUrlObject(newStringUrl: string) {
        const currentUrl = window.location.href,
            oldStringUrl = window.location.hash;

        const nextUrl = (oldStringUrl ? currentUrl.replace(oldStringUrl, '') : currentUrl) + newStringUrl;

        return { Title: newStringUrl, Url: nextUrl, type: 'obfOpen' };
    }

    private registerNotificationAndRequestHandlers() {

        const pushToDataLayer = (obj) => {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(obj);
        };

        // Push data layer to website gtm
        this.iframeCon.registerNotificationHandler('data-layer', (obj) => {
            //console.log('data layer push: ', obj);
            //push data layer
            pushToDataLayer(obj);
        });

        this.iframeCon.registerNotificationHandler('chat', (e) => {
            // console.log(e);
            if (e == 'open') {
                this.chatController.openChat(() => {
                    // console.log('User open chat from obf');
                });

            } else if (e == 'close') {
                this.chatController.closeChat(() => {

                })
            } else {
                this.chatController.feedData(e);
            }
        });

        this.iframeCon.registerNotificationHandler('click-to-call', (e) => {
            if (e && e.data && e.data.href) {
                clickToCall(e.data.href);
            }
        });

        this.iframeCon.registerNotificationHandler('chat-event', (e) => {
            this.chatController.sendEvent(e)
        });

        this.iframeCon.registerNotificationHandler('init', (e) => {
            this.clickInitEventListener();
            this.successInit();
        });

        this.iframeCon.registerNotificationHandler('show', (e) => {

            // clear all timeouts for opening obf timeout
            for (let i = 0; i < this.openingTimeOutInstance.length; i++) {
                clearTimeout(this.openingTimeOutInstance[i]);
            }

            this.showObf();
        });

        this.iframeCon.registerNotificationHandler('error', (e) => {
            console.error('error', e);
            switch (e.errorType) {
                case 'ChunkLoadError':
                    this.chunkFailToLoad(e.openModal)
                    break;
                case 'createEnv':
                    this.clickInitEventListener();
                    this.handlerErrorInitOfObf();
                    break;

                default:
                    break;
            }
        });

        this.iframeCon.registerNotificationHandler('navigation', (e) => {
            this.changeLocation({ eventType: 'change-location', data: e });
        });

        this.iframeCon.registerNotificationHandler('booking-transaction-state', (e) => {
            dispatchCustomEvent('bookingTransaction', {
                message: e.state,
                time: new Date(),
                data: e
            });
        })

        this.iframeCon.registerNotificationHandler('exit', (e) => {
            this.closeObf(e.data, e.exitData);
        });

        this.iframeCon.registerNotificationHandler('sdk-config', (e) => {
            this.xrmSdkConfig = e;
        });

        if (this.accountsController) {
            this.iframeCon.registerNotificationHandler('auth', (e) => {
                this.accountsController.handleAccountData(e);
            });

            this.iframeCon.registerNotificationHandler('csid', (e) => {
                if (e.csid) {
                    this.accountsController.setUserCookie(e.csid, e.expire_time);
                } else {
                    this.accountsController.deleteUserCookie();
                }
            });
        }

        this.iframeCon.registerRequestHandler('options', (e) => {
            return this.optionsService.getObfOptions(false);
        });

        // Get parent cookies 
        this.iframeCon.registerRequestHandler('cookies', (e) => {
            return getParentCookies();
        });

        // Get parent cookies 
        this.iframeCon.registerRequestHandler('parent-domain', (e) => {
            return window?.location?.href;
        });

    }

    private chunkFailToLoad(openModal: any) {
        this.obfState.obfIsOpen = false;
        let reloadUrl = '';

        this.obfClientSettings.main_url

        reloadUrl = this.obfClientSettings.main_url ? this.obfClientSettings.main_url.slice(0, this.obfClientSettings.main_url.length - 1) : window.location.origin;

        if (openModal) {
            this.loaderController.closeLoader();
            dispatchCustomEvent('obf-init-error', {
                status: 500,
                message: 'It looks like we have problem with the initialization!',
                time: new Date(),
            });
            this.modalController.openModal(
                undefined,
                this.defaultErrorMessage,
                '',
                (response: any) => {
                    window.location.href = reloadUrl;
                }
            );

        } else {
            window.location.href = reloadUrl;
        }
    }


    public getXrmSdkConfig() {
        return this.xrmSdkConfig;
    }

    private handlerErrorInitOfObf() {
        this.obfState.obfErrorInit = true;
        if (this.obfState.loaderStatus) {

            for (let i = 0; i < this.autoOpenTimeOutInstance.length; i++) {
                clearTimeout(this.autoOpenTimeOutInstance[i]);
            }

            this.obfState.obfIsOpen = false;
            this.obfState.loaderStatus = false;
            this.loaderController.closeLoader();
            this.iframeCon.sendNotification('navigate', 'init');
            this.changeLocation({ eventType: 'close-iframe' });
            dispatchCustomEvent('obf-init-error', {
                status: 500,
                message: 'It looks like we have problem with the initialization!',
                time: new Date(),
            });
            this.modalController.openModal(
                undefined,
                this.defaultErrorMessage,
                '',
                (response: any) => {
                    window.location.reload();
                }
            );
        }

        this.ctaButtonsController.removeSpinners();
    }

    private successInit() {
        if (!this.obfState.obfErrorInit) {
            if (this.obfState.loaderStatus) {
                this.loaderController.closeLoader();
                this.obfState.obfIsInit = true;
                this.obfState.loaderStatus = false;
                for (let i = 0; i < this.autoOpenTimeOutInstance.length; i++) {
                    clearTimeout(this.autoOpenTimeOutInstance[i]);
                }
                this.openObf(this.openLoaderAttrData);
            } else {
                this.obfState.obfIsInit = true;
            }

            this.ctaButtonsController.removeSpinners();
            this.sendChatStatus();

            dispatchCustomEvent('obf-client-loaded', {
                status: 200,
                message: 'OBF resources finished loading!',
                time: new Date(),
            });

            const obfOptions = this.optionsService.getObfClientSettings();

            if (obfOptions?.domain_url) {
                window.onbeforeunload=function(){ return null; }
            }
        }
    }

    private closeObf(close: boolean, exitData: any) {
        // console.error('CLOSE obf');
        if (close) {
            if (this.iframeRef.classList.contains('open')) {

                const obfOptions = this.optionsService.getObfClientSettings();

                if (obfOptions?.domain_url) {
                    window.location.href = obfOptions.domain_url;
                    return;
                }

                this.enableScroll();
                this.iframeRef.classList.remove('open');

                document.body.style.overflow = '';

                this.obfState.obfIsOpen = false;
                this.obfState.isClosing = true;

                // change history 
                let UrlObject = this.createUrlObject('');
                try {
                    this.defaultHistoryReplaceState.call(history, UrlObject, UrlObject.Title, UrlObject.Url);
                } catch (error) {
                    this.loaderController.openLoader();
                    window.location.reload()
                }

                history.back();
                this.showLoader(350);
                this.restoreHistoryManipulation();

                // remove class "hide" on obf close
                let elems = document.querySelectorAll('body *');

                
                Array.prototype.slice.call(elems).forEach(function (value: any) {
                    value.classList.remove('hide');
                });
                
                this.obfState.isClosing = false;
                this.iframeCon.sendNotification('navigate', 'init');
                this.changeLocation({ eventType: 'close-iframe' });
                dispatchCustomEvent('obf-status', {
                    message: 'close',
                    time: new Date()
                });
                this.resetObfOptions();
            }
        }

        this.obfState.openExitPopup = false;

        const currentQueryParams = getUrlVars();
        const isProfileChange = currentQueryParams.find((queryItem: string) => {
            if (queryItem === 'profile_id' || queryItem === 'profile') {
                return true;
            }
            return false;
        });

        if (isProfileChange) {
            window.location.href = window.location.origin + window.location.pathname;
            return;
        }

        if (exitData?.reload) {
            let reloadUrl = '';
            if (exitData.goTo === 'Home' && location.pathname !== '/' && !document.querySelector('serviceos-web-root')) {
                reloadUrl = this.obfClientSettings.main_url ? this.obfClientSettings.main_url : window.location.origin;
                window.location.href = reloadUrl;
            } else if (exitData.goTo === 'SamePage') {
                const obfOptions = this.optionsService.getObfClientSettings();

                if (obfOptions?.accounts_url && obfOptions?.accounts_url.includes(window.location.origin) && !document.querySelector('serviceos-web-root')) {
                    this.loaderController.openLoader();
                    window.location.reload()
                }

                // don't do nothing 
            } else if (exitData.goTo !== 'SamePage' && exitData.goTo !== 'Home') {
                this.loaderController.openLoader();
                window.location.href = exitData.goTo;
            }
        }
    }

    public requestConfiguration() {
        return new Promise((res, rej) => {
            this.iframeCon.sendRequest('search-configuration', {}, (response) => {
                if (response.error === 'timeout') {
                    rej(response);
                    return;
                }
                res(response);
            })
        })
    }

    

    public openObf(data?: obfButtonsDataAttributes) {
        this.openingTimeOutInstance.push(setTimeout(() => {
            // send mail report for [obf fialed to open] / timeout is cleared on obf open
            const reportData = getFormattedMailReport('Loading Timeout');
            sendReport(reportData);
        }, 25000));

        // Handler for obf error on init
        if (this.obfState.obfErrorInit) {
            this.sendUserToContactUs();
            return;
        }

        if (this.obfState.obfIsInit && !this.obfState.isClosing) {
            this.loaderController.openLoader();
            this.obfState.obfOpening = true;
            this.blockHistoryManipulation();

            const currentHistoryState = history.state;
            if (!currentHistoryState?.type || !this.firstOpen) {
                let UrlObject = this.createUrlObject('');
                UrlObject.type = 'siteState';
                this.defaultHistoryReplaceState.call(history, UrlObject, UrlObject.Title, UrlObject.Url);
                this.defaultHistoryPushState.call(history, { type: 'obfOpen' }, 'obfOpen', window.location.href);

                this.firstOpen = true;
            } else {
                history.forward();
            }

            setTimeout(() => {
                this.sendOpenDataToForm(data);
            }, 50);
        } else {
            if (data) {
                this.openLoaderAttrData = data;
            } else {
                this.openLoaderAttrData = {};
            }
            this.showLoader();
        }
    }

    private sendOpenDataToForm(data: obfButtonsDataAttributes) {
        let sendData = this.optionsService.getObfOptions(false);
        if (data) {
            Object.keys(data).map(key => {
                if (data[key]) {
                    sendData[key] = data[key];
                }
            });
        }

        if (this.accountsController) { // append csid to options and send it with opening notification.
            sendData['csid'] = this.accountsController.getUserCookie();
        }

        this.iframeCon.sendNotification('open', sendData);
    }

    private showObf() {
        this.obfIframeSettings.autoOpen = false;
        this.obfState.obfOpening = false;
        if (!this.iframeRef.classList.contains('open')) {
            if (this.lastEventFromChat?.data == 'open') {
                this.disableScroll();
            }
            this.iframeRef.classList.add('open');
            document.body.style.overflow = 'hidden';

            // add class "hide" on obf show
            let elems = document.querySelectorAll('body *:not([id^="iframe"])');

            dispatchCustomEvent('obf-status', {
                message: 'open',
                time: new Date()
            });

            Array.prototype.slice.call(elems).forEach(function (value: any) {
                // dont add hide on chat iframe
                if (value.id == 'fc_frame' || value.id == 'fc_widget') {
                    return;
                }
                value.classList.add('hide');
            });
        }

        this.obfState.obfIsOpen = true;
        this.loaderController.closeWithDelay(50);
        this.changeLocation({ eventType: 'open-iframe' });
    }

    public blockHistoryManipulation() {
        if (!this.isHistoryManipulationBlock) {
            this.isHistoryManipulationBlock = true;
            this.defaultHistoryReplaceState = history.replaceState;
            this.defaultHistoryPushState = history.pushState;
            history.replaceState = function () {
                console.warn(
                    'Outside script is trying to manipulate history with replaceState',
                    arguments
                );
            };
            history.pushState = function () {
                console.warn(
                    'Outside script is trying to manipulate history with pushState', arguments
                );
            };
        }
    }

    public restoreHistoryManipulation() {
        this.isHistoryManipulationBlock = false;
        history.replaceState = this.defaultHistoryReplaceState;
        history.pushState = this.defaultHistoryPushState;
        this.defaultHistoryReplaceState = function () { };
        this.defaultHistoryPushState = function () { };
    }

    public isInit() {
        return this.obfState.obfIsInit;
    }

    public isOpen() {
        return this.obfState.obfIsOpen;
    }

    private setStyleForIframe() {
        let styleElement = document.createElement('style');
        styleElement.innerText = '.obfIframe{width:100%;height:100%;margin:0 auto;z-index:2147483631;border:none;background-color:#fff;position:fixed;top:0;left:0;bottom:0;right:0;display:none}.obfIframe.open{display:block}#fc_frame,#fc_frame.obf-inSite{z-index:99995}#fc_frame,#fc_frame.obf-inSite.open-aboveOBF{z-index:2147483632}.add-obf-btn-spinner{position:absolute;top:0;left:0;right:0;bottom:0;margin:auto !important;display:inline-block;width:25px;height:25px;border:.2em solid rgba(255,255,255,.3);border-radius:50%;animation:1s ease-in-out infinite spin}@-webkit-keyframes spin{to{-webkit-transform:rotate(360deg)}}';
        document.head.appendChild(styleElement);
    }

    // Set Interaction script
    // private setInteractionScript() {
    //         let interactionScript = document.createElement('script');
    //         interactionScript.innerText = '!function(e,t,n,s,i,o,a,c,r){e[i]||(a=e[i]=function(){a.process?a.process.apply(a,arguments):a.queue.push(arguments)},a.queue=[],a.t=1*new Date,(c=t.createElement(n)).async=1,c.src="sos-interactions.min.js?t="+Math.ceil(new Date/o)*o,(r=t.getElementsByTagName(n)[0]).parentNode.insertBefore(c,r))}(window,document,"script",0,"sosint",864e5),sosint("init","id-web-'+window.location.hostname+'"),sosint("event","view_page",{source:"'+this.obfClientSettings.phone+'",sid:"'+encodeURIComponent(this.accountsController?.getUserCookie())+'"});';
    //         document.head.appendChild(interactionScript);        
    // }

    private resetObfOptions() {
        this.optionsService.resetObfOptions();
    }

    private sendUserToContactUs() {
        const redirectTo = this.obfClientSettings.main_url ? this.obfClientSettings.main_url : window.location.origin;
        window.location.replace(redirectTo + 'contact-us');
    }

    public disableScroll() {
        document.addEventListener('scroll', scrollWindowTop);
    }

    private enableScroll() {
        document.removeEventListener('scroll', scrollWindowTop);
    }
}

